var PageMyOrders = (function ($) {

    PageMyOrders = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$orders_list = that.$wrapper.find('.js-orders-list');
        that.$load_more_wrapper = that.$wrapper.find('.js-load-more-wrapper');

        // CONST
        that.page = options['page'];
        that.filter_status = options['filter_status'];

        that.classes = {
            sticky_observer: 'js-sticky-observer',
            is_stick: 'is-stick',
            disabled: 'disabled'
        }

        // INIT
        that.init();
    };

    PageMyOrders.prototype.init = function () {
        var that = this;

        //
        $.sa.stickyObserver('.' + that.classes.sticky_observer, that.classes.is_stick);

        that.initPagination();
    };

    PageMyOrders.prototype.initPagination = function () {
        var that = this,
            list_url = $.sa.build_url('my/orders/list');

        $.sa.pagination(that.$wrapper, list_url, {status: that.filter_status});
    };

    return PageMyOrders;
})($);